/**
 * 프린터 추가 모달
 */
import { inject, observer } from "mobx-react";
import { Modal } from "components/modal/compound/Modal";
import { fn_setPrintCheckInit, fn_setPrintCheckFlagSave } from "function/FnBodySetting";
import { Button } from "components/ui/Button";
import FormField from "components/ui/FormField";
import addSelectIcon from "static-file/images/add_select_icon.png";
import modalStore from "stores/ModalStore";
const PrintAdd = ({ rootStore }: any) => {
  const { layerStore, searchStore, settingStore } = rootStore;

  function openSelectBox(type: string) {
    if (type === "baudrate") {
      searchStore.setPrintAddSelectVal("title", "출력 속도 선택");
      searchStore.setPrintAddSelectVal("list", searchStore.getPrintAddSelectBaudRate);
    }

    if (type === "port") {
      let comList: string[] = [];
      settingStore.getPrinterInfo.availableComPorts.filter(
        (element: { portName: string; protNo: string }, index: number) => {
          comList[index] = element.portName;
        }
      );
      searchStore.setPrintAddSelectVal("title", "연결포트 선택");
      searchStore.setPrintAddSelectVal("list", comList);
    }

    if (searchStore.getPrintAddSelectVal.list.length === 0 && type === "port") {
      layerStore.setLayerAlertType("print_add_port");
      layerStore.setLayerAlertView(true);
    } else {
      modalStore.openModal("printAddSelect", {});
    }
  }

  return (
    <Modal.BackGround containerWidth="374px" border={true}>
      <Modal.Header
        title={"프린터 추가"}
        onClose={() => {
          modalStore.closeModal("printAdd");
        }}
      />
      <Modal.Content>
        <Modal.CommonContent text="추가할 프린터 정보를 입력해주세요" className="flex flex-col gap-4 !items-start" />
        <FormField direction="col">
          <FormField.Label htmlFor="printNm">프린터 이름</FormField.Label>
          <FormField.Input id="printNm" placeholder="프린터 이름을 입력해주세요" type="text" maxLength={10} />
        </FormField>
        <FormField direction="col">
          <FormField.Label htmlFor="port">연결 포트</FormField.Label>
          <FormField.Input
            id="port"
            placeholder="연결 포트를 선택해주세요"
            type="text"
            readOnly={true}
            onClick={() => openSelectBox("port")}
          />
          <FormField.Icon position="right">
            <img src={addSelectIcon} alt="add_select_icon" />
          </FormField.Icon>
        </FormField>
        <FormField direction="col">
          <FormField.Label htmlFor="baudRate">출력 속도</FormField.Label>
          <FormField.Input
            id="baudRate"
            placeholder="출력 속도를 선택해주세요"
            type="text"
            readOnly={true}
            onClick={() => openSelectBox("baudrate")}
          />
          <FormField.Icon position="right">
            <img src={addSelectIcon} alt="add_select_icon" />
          </FormField.Icon>
        </FormField>
      </Modal.Content>

      <Modal.Divider className="!mt-2" />
      <Modal.Bottom>
        <Button
          variant="white"
          size="sm"
          onClick={() => {
            modalStore.closeModal("printAdd");
            fn_setPrintCheckInit(rootStore);
          }}
          className="!font-bold"
        >
          취소
        </Button>
        <Button
          variant="default"
          size="sm"
          onClick={() => {
            fn_setPrintCheckFlagSave(rootStore);
            modalStore.closeModal("printAdd");
          }}
          className="!font-bold"
        >
          등록
        </Button>
      </Modal.Bottom>
    </Modal.BackGround>
  );
};
export default inject("rootStore")(observer(PrintAdd));
